/* eslint-disable no-unused-expressions */
const stateKeys = {}

const initialState = {
  loadedFeatureFlag: null,
  userHasFeatureFlagQrScanner: false,
  featureFlagMaintenance: null,
  featureFlagSentryData: false
}

const defaultState = { ...initialState }

export const state = () => defaultState

export const mutations = {
  clearStorage(state) {
    for (const [key] of Object.entries(state)) {
      state[`${key}`] = state[key]
    }
  },
  setLoadedFeatureFlag(state, value) {
    state.loadedFeatureFlag = value
  },
  setUserHasFeatureFlagQrScanner(state, value) {
    state.userHasFeatureFlagQrScanner = value
  },
  setFeatureFlagMaintenance(state, value) {
    state.featureFlagMaintenance = value
  },
  setFeatureFlagSentryData(state, value) {
    state.featureFlagSentryData = value
  }
}

export const actions = {
  clearStorage({ commit }) {
    for (const prop in stateKeys) {
      this.$storage.removeUniversal(stateKeys[prop])
    }
    commit('clearStorage')
  },
  setLoadedFeatureFlag({ commit, rootState }, value) {
    commit('setLoadedFeatureFlag', value)

    const featureFullyVisibleOnEnvironment = this.$firebase?.remoteConfig
      ?.featureFullyVisibleOnEnvironment
    const featureFlag = this.$firebase?.remoteConfig?.featureFlag

    commit(
      'setFeatureFlagMaintenance',
      featureFullyVisibleOnEnvironment?.underMaintenance[process.env.envName]
        ? featureFlag?.underMaintenance
        : false
    )
    commit(
      'setUserHasFeatureFlagQrScanner',
      !!featureFlag?.qrScanner?.find(
        (user) => user === rootState.gigyaProfile?.email
      ) || featureFullyVisibleOnEnvironment?.qrScanner[process.env.envName]
    )
    commit(
      'setFeatureFlagSentryData',
      featureFullyVisibleOnEnvironment?.sentryData[process.env.envName]
        ? featureFlag?.sentryData
        : false
    )
  }
}
